export default __webpack_public_path__ + "static/media/caen18.4b48e4eb.jpg";